'use client'

import { CollectionContainer } from '@/components/common/collection/collection-container'
import { useFlashSale } from '@/hooks/react-query/flash-sale/use-flash-sale'
import { useEffect, useState } from 'react'
import { BannerCountDown } from './banner-count-down'
import { ProductFlashSale } from './product-flash-sale'

export const FlashSale = () => {
  const { data: flashSales } = useFlashSale()
  const [activeTab, setActiveTab] = useState<string>('current-0')
  const [type, indexStr] = activeTab.split('-')
  const index = parseInt(indexStr) || 0
  const selectedProgram = flashSales?.[type as 'current' | 'next']?.[index]
  const products = selectedProgram?.products || []

  useEffect(() => {
    if (flashSales) {
      if (flashSales.current?.length) {
        // eslint-disable-next-line react-hooks/set-state-in-effect -- setting default active tab once query data loads
        setActiveTab('current-0')
      } else if (flashSales.next?.length) {
        setActiveTab('next-0')
      }
    }
  }, [flashSales])

  if (!flashSales || (!flashSales.current?.length && !flashSales.next?.length))
    return null

  return (
    <CollectionContainer>
      <BannerCountDown
        countDownTime={flashSales.countDownTime}
        current={flashSales.current || []}
        next={flashSales.next || []}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
      />
      <ProductFlashSale
        products={products}
        type={type as 'current' | 'next'}
      />
    </CollectionContainer>
  )
}
